import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ad657f30"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "directions-content h-100" }
const _hoisted_2 = { class: "h-100" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "confirmation-circle" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check-circle" })
], -1))
const _hoisted_4 = { class: "confirmation-title m-0" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "confirmation-disclaimer m-1" }, " We can’t guarantee this trailer, but won't allow other drivers to be dispatched onto it. ", -1))
const _hoisted_6 = {
  key: 0,
  class: "droplot-disclaimer m-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SidebarConfirmation = _resolveComponent("SidebarConfirmation")!
  const _component_Sidebar = _resolveComponent("Sidebar")!

  return (_openBlock(), _createBlock(_component_Sidebar, { sideBarHeight: 448 }, {
    "sidebar-content": _withCtx(() => [
      _createVNode(_component_SidebarConfirmation, {
        acceptText: `Return to ${_ctx.returnApp} for Navigation`,
        rejectText: "New Search",
        rejectTheme: "linkItalic",
        onAccept: _ctx.routeToDashboard,
        onReject: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'DriverLanding' })))
      }, {
        "main-content": _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("div", null, [
                _createElementVNode("h4", _hoisted_4, [
                  _createTextVNode(" Trailer held until "),
                  _createElementVNode("b", null, _toDisplayString(_ctx.expirationTime), 1),
                  _createTextVNode(" " + _toDisplayString(_ctx.expirationZone), 1)
                ]),
                _hoisted_5,
                (_ctx.hasMultipleParcels)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_6, " This location might be a drop lot. "))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["acceptText", "onAccept"])
    ]),
    _: 1
  }))
}